//import { apiUrl as api_url } from "utils/helpers/enviroment.helpers";
//import { parseJwt } from "utils/helpers/jwt.helpers";
import { parseJwt } from "../utils/helpers/jwt.helpers";
import { getTitular } from "./serviceTitular";
import { handleErrors } from "./httpService";

const api_path = "auth";

const login = async (dni, fechaNacimiento) => {

    console.log("login", `${window.__CONFIG__.apiPrincipal}${api_path}/afiliado`, dni, fechaNacimiento);

    return fetch(`${window.__CONFIG__.apiPrincipal}${api_path}/afiliado`, {
        headers: {
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Expires': '0'
        },
        method: 'POST',
        body: JSON.stringify({
            dni: dni,
            fechaNacimiento: fechaNacimiento
        })
    })
    .then(handleErrors)
    .then(res => res.json()).then(authResponse => {
        return authResponse;
    }).catch(err => {throw err});
}

const refreshAuth = async (token, refreshToken) => {
    // console.log("REFRESH AUTH", {
    //     'token': token,
    //     'refreshToken': refreshToken
    // }, `${api_url}${api_path}/refresh`)
    return fetch(`${window.__CONFIG__.apiPrincipal}${api_path}/refresh`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Expires': '0'
        },
        body: JSON.stringify({
            'token': token,
            'refreshToken': refreshToken
        })
    })
}

const fromTokenToUsuario = async (token) => {
    
    // console.log('fromTokenToUsuario', token);

    if (!token) return {}

    const payload = parseJwt(token);
    console.log('1) fromTokenToUsuario -token-payload', token, payload);

    return await getTitular(payload.nameid)//, payload.role)
        .then(titular => {
            console.log("2) fromTokenToUsuario - titular", titular);
            return titular
        })
        .catch(err => console.error("Error en fromTokenToUsuario", err));
}

export {
    login,
    fromTokenToUsuario,
    refreshAuth
};